<template>
	<div>
		<div style="width:1200px;margin: 0 auto;">
			<div class="dingdan">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  <el-breadcrumb-item>个人中心</el-breadcrumb-item>
				  <el-breadcrumb-item>个人信息</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="fh_button">
					<i class="el-icon-arrow-left"></i>
					<p>返回</p>
				</div>
			</div>
			<ul class="userbox">
				<li>
					<div class="userbox1">
						<div>头像</div>
						<img :src="user.avatar" alt="" srcset="" />
					</div>
					<p>更换头像</p>
				</li>
				<li>
					<div class="userbox1">
						<div>昵称</div>
						<span>{{user.nickname}}</span>
					</div>
					<p>编辑昵称</p>
				</li>
				<li>
					<div class="userbox1">
						<div>手机号码</div>
						<span>{{user.phone}}</span>
					</div>
					<p></p>
				</li>
				<li>
					<div class="userbox1">
						<div>邀请好友</div>
						<span>分享好友</span>
					</div>
					<p>生成邀请链接</p>
				</li>
			</ul>
			<diV class="userbox" 
			     style="margin-top:20px;
				        display:flex;
						justify-content:space-between;
						align-items: center;">
				<div class="userboxTj">
					<h4>是否加入评审团参与纠纷调解</h4>
					<p>参与评审团可获得评审金奖励</p>
				</div>
				<el-switch
					  v-model="value"
					  @change="switch2Change"
					  active-color="#1E3A8A"
					  inactive-color="#cccccc">
				</el-switch>
			</diV>
			<div class="FBxqFooter">
				<div class="FBxqFooter1">退出登录</div>
				<div class="FBxqFooter2">保存</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		personal,
		UserUpdate,
		Userlogout
	} from "@/api/api.js"
	// import rightsidebarImg from '@/common/rightsidebarImg.vue';
	export default {
	  name: 'HelloWorld',
	 //  components:{
		// rightsidebarImg  
	 //  },
	  data() {
	    return {
			radio:'1',
			type: true,
			user:'',
			valiFormData: {
				company_name: '',
				tax_id:'',
				email:"",
			},
}
	  },
	  created() {
	  	this.userinfo()
	  },
	  methods: {
		userinfo(){
			personal({}).then(res=>{
				this.user=res.data.data
				if(this.user.review_status==1){
					this.value=true
				}else{
					this.value=false
				}
			})
		},
		onChooseAvatar(e) {
			this.avatarUrl = e.detail.avatarUrl;
			let filePath= this.avatarUrl
			// uni.uploadFile({
			// 	url:APIIMG+'api/Upload/upload',
			// 	filePath,
			// 	method: 'POST',
			// 	name: 'file',
			// 	success: (res) => {
			// 		let img=JSON.parse(res.data)
			// 		this.content_image=img.data
			// 		if(this.content_image){
			// 			this.setuserinfo()
			// 		}
			// 	},
			// 	fail: (uploadFileErr) => {
			// 		// console.log(uploadFileErr,"fanhui")
			// 	}
			// });
		},
		switch2Change(e){
			let review_status=""
			if(this.value==true){
				review_status="1"
			}
			if(this.value==false){
				review_status="0"
			}
			UserUpdate({
				review_status:review_status
			}).then(res=>{
				console.log(res)
				this.userinfo()
			})
		},
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.userbox{
		width:100%;
		background-color:#fff;
		padding:12px;
		box-sizing: border-box;
		border-radius:12px;
	}
	.userbox img{
		width: 42px;
		height:42px;
		border-radius:50%;
	}
	.userbox li{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		padding: 10px 0px;
	}
	.userbox1{
		display:flex;
		align-items: center;
	}
	.userbox1 div{
		width: 160px;
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}
	.userbox1 span{
		font-weight: 500;
		font-size: 16px;
		color: #333333;
	}
	.userbox li>p{
		font-weight: 500;
		font-size: 16px;
		color: #4297FF;
		cursor:pointer;
	}
	.userboxTj h4{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.userboxTj p{
		font-weight: 400;
		font-size: 14px;
		color: #1E3A8A;
	}
	.FBxqFooter{
		width:100%;
		padding:30px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:center;
		align-items:center;
	}
	.FBxqFooter1{
		width: 112px;
		height: 40px;
		background: rgba(30,58,138,0.15);
		border-radius: 8px ;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 16px;
		color: #1E3A8A;
		cursor:pointer;
	}
	.FBxqFooter2{
		width: 112px;
		height: 40px;
		background: #1E3A8A;
		border-radius: 8px ;
		margin-left:32px;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		cursor:pointer;
	}
</style>